module.exports = __webpack_public_path__ + "static/media/IBES-LOGO.5a8d1d82.png";